

















import Vue from 'vue'
import Component from 'vue-class-component'

@Component<ButtonWithCheckMark>({
  props: {
    active: Boolean,
    title: String,
    hoverText: String,
    disable: Boolean,
    isOneLine: Boolean
  }
})

export default class ButtonWithCheckMark extends Vue {
  /**
   * Props variables
   */
  active: Boolean = false
  title: string = ""
  hoverText: string = ""
  disable: boolean = false
  isOneLine: boolean = false

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */

  /**
   * Getters
   */


  /**
   * Methods
   */
  emitClick() {
    this.$emit('emitClick')
  }
}
